import React, { useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialValue = {
  token: null,
  avatar: null,
  chats: null,
  currentChatId: null,
  currentChat: null,
  currentChatTrigger: '',
  startSessionDate: Date.now(),
};

const context = React.createContext();

function Context({ children }) {
  const [state, dispatch] = useReducer(reducer, initialValue);

  const value = useMemo(() => ({ state, dispatch, actions }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

Context.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useContext = () => React.useContext(context);
export default Context;
